import dayjs from "@/lib/helpers/dayjs";
import type { Note } from "@/core/types";

import type { DateFields } from "./format-completed-date-time";

export function resolveIcaDates(note: Note): DateFields {
  const patientNoShowTime = (
    note.content?.patient_no_show_array as Array<{ patient_no_show_time?: string }> | undefined
  )?.[0]?.patient_no_show_time;

  if (patientNoShowTime && !note.completed_date_time) {
    return {
      displayDate: dayjs(patientNoShowTime).format("MM/DD/YYYY"),
      displayTime: dayjs(patientNoShowTime).format("hh:mm A"),
      isoDate: dayjs(patientNoShowTime).toISOString(),
    };
  }

  return {
    displayDate: note.completed_date_time
      ? dayjs.utc(note.completed_date_time).local().format("MM/DD/YYYY")
      : null,
    displayTime: note.completed_date_time
      ? dayjs.utc(note.completed_date_time).local().format("hh:mm A")
      : null,
    isoDate: note.completed_date_time ? dayjs.utc(note.completed_date_time).toISOString() : null,
  };
}
